import { useEffect, useCallback, useContext } from "react";

import { toast } from "react-toastify";
import { AuthContext } from "../../../../context/AuthContext";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useGerarRelatoriosOcorrencia = ({ dadosOs, itemOcorrencia }) => {
  const {
    request: requestDownload,
    data: dataDownload,
    errors: errorDownload,
    isLoading: isLoadingOcorrencia,
  } = useApiClient();
  const { user } = useContext(AuthContext);

  const handleImprimirResumo = useCallback(() => {
    const dados = {
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialOrdemServico: dadosOs.sequencial,
      inscricaoEstadual: dadosOs.inscricaoEstadual,
      numCnpj: dadosOs.cnpjCpf,
      razaoSocial: dadosOs.razaoSocial,
      enderecoContribuinte: dadosOs.enderecoContribuinte,
      matriculaUsuario: user.matricula,
      dtInicioFiscalizacao: dadosOs.dataInicialFiscalizacao,
      dtFimFiscalizacao: dadosOs.dataFinalFiscalizacao,
      listaOcorrencias: itemOcorrencia,
    };

    requestDownload(apiRoutes.fiscalizacao.ocorrencia.gerarResumoOcorrencia, dados);
  }, [requestDownload, dadosOs, itemOcorrencia, user]);

  const handleImprimirDemonstrativo = useCallback(() => {
    const dados = {
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialOrdemServico: dadosOs.sequencial,
      inscricaoEstadual: dadosOs.inscricaoEstadual,
      numCnpj: dadosOs.cnpjCpf,
      razaoSocial: dadosOs.razaoSocial,
      enderecoContribuinte: dadosOs.enderecoContribuinte,
      matriculaUsuario: user.matricula,
      dtInicioFiscalizacao: dadosOs.dataInicialFiscalizacao,
      dtFimFiscalizacao: dadosOs.dataFinalFiscalizacao,
      listaOcorrencias: itemOcorrencia,
    };

    requestDownload(apiRoutes.fiscalizacao.ocorrencia.gerarDemonstrativoOcorrencia, dados);
  }, [requestDownload, dadosOs, itemOcorrencia, user]);

  // download
  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return { handleImprimirResumo, handleImprimirDemonstrativo, isLoadingOcorrencia };
};

export default useGerarRelatoriosOcorrencia;
